<template>
	<div style="padding: 10px;">
		历史订单
		
	</div>
</template>

<script>
	export default {
		name : 'HistoryOrders',
		data() {
			return {
				
				
			}
		},
		mounted() {
			
		},
		methods: {
			
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>